module.exports = __webpack_public_path__ + "static/media/checkmark.f49fc689.svg";